/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Generate_SectionInputs */

const cs_property_ai_generate_section = /** @type {(inputs: Property_Ai_Generate_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat popis`)
};

const en_property_ai_generate_section = /** @type {(inputs: Property_Ai_Generate_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate description`)
};

/**
* | output |
* | --- |
* | "Generate description" |
*
* @param {Property_Ai_Generate_SectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_generate_section = /** @type {((inputs?: Property_Ai_Generate_SectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Generate_SectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_generate_section(inputs)
	return cs_property_ai_generate_section(inputs)
});